import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as api from '../../api';
import { IconButton, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip } from '@material-ui/core';
import { CloseOutlined as CloseIcon } from '@material-ui/icons'
import produce from 'immer';


function Users(props) {
  const { business } = props;

  const [members, setMembers] = useState([]);
  
  useEffect(() => {
    api.getBusienssMembers(business.id)
      .then(res => setMembers(res))
      .catch(err => console.log(err));
  }, [business]);

  const removeMember = (memberId) => {
    api.deleteMember(memberId)
      .then(res => {
        const nextState = produce(members, draftState => {
          var idx = members.findIndex(x => x.id === memberId);
          if (idx >= 0) draftState.splice(idx, 1);
          return draftState;
        });

        setMembers(nextState);
      })
      .catch(err => console.warn(err));
  }

  const handleChange = (memberId, key, val) => {
    api.updateMember(memberId, { [key]: val })
      .then(res => {
        const nextState = produce(members, draftState => {
          var idx = draftState.findIndex(x => x.id === memberId);
          draftState[idx][key] = val;
          return draftState;
        });

        setMembers(nextState);
      })
      .catch(err => console.warn(err));
  }

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Role</TableCell>
            <TableCell>Options</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {members.map(({ user, ...member }) => (
            <TableRow key={member.id}>

              <TableCell>{user.firstName} {user.lastName}</TableCell>

              <TableCell>{user.email}</TableCell>

              <TableCell>
                <TextField
                  select
                  value={member.rank}
                  onChange={evt => handleChange(member.id, 'rank', evt.target.value)}
                >
                  <MenuItem value={0}>Owner</MenuItem>
                  <MenuItem value={1}>Admin</MenuItem>
                  <MenuItem value={2}>Staff</MenuItem>
                </TextField>
              </TableCell>

              <TableCell>
                <Tooltip title='Remove'>
                  <IconButton
                    size='small'
                    onClick={() => removeMember(member.id)}
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </TableCell>

            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

Users.propTypes = {
  business: PropTypes.object
}


export default Users;
